import type { IconNode } from '../types';

/**
 * @name square-padding
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB4PSIzIiB5PSIzIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik0xNCAxN2gtNCIgLz4KICA8cGF0aCBkPSJNMTQgN2gtNCIgLz4KICA8cGF0aCBkPSJNMTcgMTR2LTQiIC8+CiAgPHBhdGggZD0iTTcgMTR2LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/square-padding
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SquarePadding: IconNode = [
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2' }],
  ['path', { d: 'M14 17h-4' }],
  ['path', { d: 'M14 7h-4' }],
  ['path', { d: 'M17 14v-4' }],
  ['path', { d: 'M7 14v-4' }],
];

export default SquarePadding;
